import { type BlogFrontmatter } from "@/services/blog.ts";
// eslint-disable-next-line no-restricted-imports
import headerImage from "./header_image.avif";
// eslint-disable-next-line no-restricted-imports
import { height, width } from "./header_image.avif?as=metadata:height;width";
// eslint-disable-next-line no-restricted-imports
import headerImageSrcset from "./header_image.avif?w=480;960;1920&format=avif&as=srcset";

export const frontmatter: BlogFrontmatter = {
  title: "Verklig säkerhet först, ISO 27001 sedan",
  header: "Verklig säkerhet först, ISO 27001 sedan",
  date: "2025-08-13",
  description:
    "Varför du ska bygga upp riktig säkerhet innan du rusar in i certifieringar som ISO 27001.",
  category: "säkerhet",
  draft: false,
  authorKey: "agnes_onne",
  headerImage,
  headerImageSrcset,
  headerImageDimensions: {
    height,
    width,
  },
};
